import * as React from 'react';

import * as styles from './OutsideIcon.css';

export const OutsideIcon: React.FC = () => <div className={styles['icon']} />;
